/**
 * @generated SignedSource<<ae88912a538bc09263955feb733681ab>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedMarketTrendsIconicDesigns_creatorMarketTrends$data = {
  readonly iconicDesigns: ReadonlyArray<{
    readonly iconicDesign: {
      readonly authorityImageUrl: string | null;
      readonly displayName: string | null;
      readonly urlLabel: string | null;
    } | null;
    readonly priceStats: {
      readonly avgSalePrice: {
        readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
      } | null;
      readonly priceRange: {
        readonly high: {
          readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
        } | null;
        readonly low: {
          readonly " $fragmentSpreads": FragmentRefs<"currencyHelpers_financialAmount">;
        } | null;
      } | null;
      readonly valueChange: number | null;
    } | null;
  } | null> | null;
  readonly topicDescription: {
    readonly isPlural: boolean | null;
  } | null;
  readonly " $fragmentType": "SbSharedMarketTrendsIconicDesigns_creatorMarketTrends";
};
export type SbSharedMarketTrendsIconicDesigns_creatorMarketTrends$key = {
  readonly " $data"?: SbSharedMarketTrendsIconicDesigns_creatorMarketTrends$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedMarketTrendsIconicDesigns_creatorMarketTrends">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "currencyHelpers_financialAmount",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConvertedAmountList",
        "kind": "LinkedField",
        "name": "convertedAmountList",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "amount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "args": null,
    "argumentDefinitions": ([]/*:: as any*/)
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedMarketTrendsIconicDesigns_creatorMarketTrends",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketTrendsTopicDescription",
      "kind": "LinkedField",
      "name": "topicDescription",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPlural",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MarketTrendsIconicDesign",
      "kind": "LinkedField",
      "name": "iconicDesigns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MarketTrendsPriceStats",
          "kind": "LinkedField",
          "name": "priceStats",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "valueChange",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "FinancialAmount",
              "kind": "LinkedField",
              "name": "avgSalePrice",
              "plural": false,
              "selections": (v0/*:: as any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MarketTrendsPriceRange",
              "kind": "LinkedField",
              "name": "priceRange",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "low",
                  "plural": false,
                  "selections": (v0/*:: as any*/),
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FinancialAmount",
                  "kind": "LinkedField",
                  "name": "high",
                  "plural": false,
                  "selections": (v0/*:: as any*/),
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IconicDesign",
          "kind": "LinkedField",
          "name": "iconicDesign",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "authorityImageUrl",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MarketTrendsConnection",
  "abstractKey": null
};
})();

(node as any).hash = "0ffb02c0621522b258ab48dd068bbadf";

export default node;
